import React from 'react'
const SvgProvide8 = props => (
  <svg id='provide8_svg___\u56FE\u5C42_2' data-name='\u56FE\u5C42 2' viewBox='0 0 47.81 48' {...props}>
    <defs>
      <style>
        {
          '.provide8_svg__cls-1{fill-rule:evenodd;fill:#334966;stroke-width:0}.provide8_svg__cls-3{stroke-width:0;fill:#fd5c1f}'
        }
      </style>
    </defs>
    <g id='provide8_svg___\u56FE\u5C42_1-2' data-name='\u56FE\u5C42 1'>
      <path
        className='provide8_svg__cls-1'
        d='M36.91 13.39v-2h-5v-2h-2v2h-12v-2h-2v2h-5v4h2v-2h22v2h2v-2zM36.91 31.28h-2v2H12.9v-2h-2v4h5v2h2v-2h12v2h2v-2h5v-4z'
      />
      <path
        d='M24 48C10.77 48 0 37.23 0 24S10.77 0 24 0c11.52 0 21.44 8.2 23.58 19.5l-1.96.37C43.66 9.51 34.57 1.99 24.01 1.99 11.87 2 2 11.87 2 24s9.87 22 22 22c11.08 0 20.46-8.27 21.83-19.25l1.98.25C46.32 38.97 36.08 48 24 48z'
        strokeWidth={0}
        fill='#334966'
      />
      <path
        className='provide8_svg__cls-3'
        d='M14.74 28.37c-1.57 0-2.85-.29-3.89-1.36l1.61-1.61c.53.53 1.47.72 2.29.72.99 0 1.47-.33 1.47-.92 0-.25-.06-.45-.2-.61-.13-.13-.35-.23-.68-.27l-1.24-.17c-.91-.13-1.6-.43-2.06-.91-.48-.49-.71-1.18-.71-2.06 0-1.87 1.41-3.24 3.75-3.24 1.47 0 2.58.35 3.46 1.23l-1.59 1.59c-.65-.65-1.5-.61-1.95-.61-.88 0-1.24.5-1.24.95 0 .13.04.32.2.48.13.13.35.26.71.3l1.24.17c.92.13 1.59.42 2.02.85.55.53.76 1.3.76 2.25 0 2.09-1.8 3.23-3.97 3.23zM23.58 28.37c-1.57 0-2.86-.29-3.89-1.36l1.62-1.61c.53.53 1.47.72 2.29.72 1 0 1.47-.33 1.47-.92 0-.25-.06-.45-.2-.61-.13-.13-.35-.23-.68-.27l-1.24-.17c-.91-.13-1.6-.43-2.06-.91-.48-.49-.71-1.18-.71-2.06 0-1.87 1.41-3.24 3.75-3.24 1.47 0 2.58.35 3.46 1.23l-1.59 1.59c-.65-.65-1.5-.61-1.95-.61-.88 0-1.24.5-1.24.95 0 .13.04.32.2.48.13.13.35.26.71.3l1.24.17c.92.13 1.59.42 2.02.85.55.53.76 1.3.76 2.25 0 2.09-1.8 3.23-3.96 3.23zM35.93 27.22c-.75.75-1.61 1.15-2.87 1.15s-2.12-.4-2.87-1.15c-1.08-1.08-1.04-2.52-1.04-4.07s-.04-2.98 1.04-4.07c.75-.75 1.61-1.15 2.87-1.15s2.12.4 2.87 1.15c1.08 1.08 1.04 2.52 1.04 4.07s.04 2.98-1.04 4.07zm-1.86-6.59c-.19-.25-.55-.45-1.01-.45s-.82.2-1.01.45c-.23.3-.37.65-.37 2.52s.14 2.21.37 2.51c.19.25.55.46 1.01.46s.82-.22 1.01-.46c.23-.3.37-.63.37-2.51s-.14-2.22-.37-2.52z'
      />
    </g>
  </svg>
)
export default SvgProvide8
